import { render, staticRenderFns } from "./MainBody.vue?vue&type=template&id=3087534b&"
import script from "./MainBody.vue?vue&type=script&lang=js&"
export * from "./MainBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports